import { Outlet } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { SplitHeroShell } from './SplitHeroShell';

export function CheckoutLayout(): ReactElement {
    return (
        <SplitHeroShell contentMaxWidth={680} contentSpacing={6}>
            <Outlet />
        </SplitHeroShell>
    );
}
